module.exports = __webpack_public_path__ + "static/Explore_synergies_2x-2d3f0b0e0c96dc8d65f26a29f0d5378b.png";